import { FILTER_CONTEXT_LABELS, FILTER_CONTEXTS } from "@search/api/constants";
import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class EurotunnelFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: FILTER_CONTEXT_LABELS[FILTER_CONTEXTS.eurotunnel],
      name: "le-shuttle",
      value,
    });
  }
}

export default EurotunnelFilter;
export { EurotunnelFilter };
